module.exports = __webpack_public_path__ + "media/images/illustrations/Icon-Applicants-70f809eae66f0a572cfd0a54810dfa23.svg";